import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RestaurantHeader from '../components/blocks/restaurantHeader';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as AlertContext } from '../context/alert';
import { Context as AuthContext } from '../context/auth';
import MainLayout from '../layouts/mainLayout';
import Loader from '../components/misc/loader';
import { restaurantTypes } from '../enums/restaurantTypes';
import RecentOrders from '../features/order/components/customOrder/recentOrders';
import MainButton from '../components/buttons/main';
import { useTableSseConnection } from '../hooks/useTableSseConnection';
import { useInterval } from '../hooks/useInterval';

const OrdersPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useTableSseConnection();

  const { state: restaurantState, getOrders } = useContext(RestaurantContext);
  const { alertController } = useContext(AlertContext);
  const { state: authState } = useContext(AuthContext);

  const getOrdersAsync = async (isFirstRequest) => {
    const { locked, orders } = await getOrders({
      tableId: restaurantState.table.id,
      userId: authState.user ? authState.user.id : null,
      restaurantType: restaurantState.restaurant.type,
      inBackground: !isFirstRequest,
    });
    if (!locked && (!orders || orders.length === 0)) {
      alertController.warning({ text: t('errors.noOrdersYet') });
      navigate('/', { replace: true });
    }
  };

  useEffect(() => {
    if (restaurantState.restaurant.type !== restaurantTypes.OrderAndPay) {
      navigate('/', { replace: true });
      return;
    }

    if (restaurantState.ordersGot) {
      return;
    }

    getOrdersAsync(true);
  }, [restaurantState.ordersGot]);

  // reget orders every 30s (if there is problem with server events)
  useInterval(getOrdersAsync, 30000, false);

  // Loading table
  if (restaurantState.loadingOrders || !restaurantState.ordersGot) {
    return <Loader />;
  }

  const anyOrders = restaurantState.orders && restaurantState.orders.length > 0;

  return (
    <MainLayout showPayments>
      <RestaurantHeader
        restaurant={restaurantState.restaurant}
        table={restaurantState.table}
        canHomeNavigate
      />
      <div className="mt-2" />
      <MainButton text={t('buttons.viewMenu')} outline onClick={() => navigate('/menu')} />
      <div className="mt-3" />
      {!anyOrders && (
        <div className="flex justify-center">
          <p className="font-primaryMedium text-primary text-lg">{t('errors.noOrdersYet')}</p>
        </div>
      )}
      {!!anyOrders && (
        <RecentOrders table={restaurantState.table} orders={restaurantState.orders} />
      )}
    </MainLayout>
  );
};

export default OrdersPage;
